import styled from "styled-components"

export const BaseButton = styled.button`
  display: flex;
  font-family: "Rubik", sans-serif;

  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1.25rem 1.5rem;
  font-size: 1rem;
  color: #ffffff;
  font-weight: 500;
  width: 15;
  height: 3.1875rem;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius:999px;
  transition: all 0.3s ease;
  background: linear-gradient(#C5942C, #C5942C);
  box-shadow: 0px 0.5625rem 0.875remrgba(197, 149, 44, 0.27);
  &:hover {
    transition: all 0.3s ease;
    background: linear-gradient(#A6740C, #A6740C);
    box-shadow: none;
  }
  @media screen and (max-width: 1000px) {
    width: 100%;
    padding: 1.25rem 1.5rem;
    width: 100%;
    height: 51px;
  }
`
